<template>
  <BContainer
    class="px-0"
    fluid
  >

    <BRow
      v-if="busy"
      class="mb-3"
    >
      <BCol
        cols="12"
      >
        <div class="text-center py-5">
          <BIcon
            icon="stopwatch"
            font-scale="5"
            animation="cylon"
          />
          <p class="h3 py-2">
            <strong>Loading . . .</strong>
          </p>
        </div>
      </BCol>
    </BRow>

    <BRow
      v-else-if="Number(tasks.totalRows) <= 0 && !busy"
    >
      <BCol
        cols="12"
        class="text-center py-5"
      >
        <BIcon
          icon="calendar"
          font-scale="5"
        />
        <p class="h3 py-2">
          <strong>No officer tasks found</strong>
        </p>
      </BCol>
    </BRow>

    <BRow
      v-else
      class="gap-y-6"
    >

      <BCol
        v-for="activity in tasks.rows"
        :key="activity?.id"
        cols="12"
        md="6"
      >
        <Task
          :activity="{
            activity_name: activity.activity_name,
            total_buyers: activity.customers_bought_count
          }"
          :current-progress="{
            event: activity.events_count,
            customer: activity.customers_attended_count,
            hectare: activity.total_actual_hectares,
            cost: activity.total_actual_costs,
            sales: activity.total_actual_sales
          }"
          :total-progress="{
            event: activity.event_plan,
            customer: activity.total_customer_plan,
            hectare: activity.total_hectare_plan,
            cost: activity.total_budget_plan,
            sales: activity.total_sales_plan
          }"
        />
      </BCol>
    </BRow>
  </BContainer>
</template>
<script>
import Task from '@/views/audit/dashboard/components/Task.vue'

export default {

  name: 'VAuditDashboard',

  components: {
    Task
  },

  middleware: ['auth', 'audit'],

  props: {
    busy: {
      type: Boolean,
      default: () => false
    },
    tasks: {
      type: Object,
      default: () => ({
        totalRows: 0,
        rows: []
      })
    }
  }

}
</script>
